import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { isNull, uniq } from 'lodash';
import moment from 'moment';
import qs from 'querystringify';
import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';
import ListItem from './ListItem';
import { Loading, Pagination, Table, Box } from '../../../components/elements';
import client from '../../../utils/apolloClient';

const imageReviewsQuery = gql`
  query searchImageReviews($input: SearchInput) {
    search_image_review(input: $input) {
      total_pages
      total_size
      image_review_listing {
        image_id
        object_id
        object_type
        parent_name
        parent_id
        parent_type
        upload_type
        approval_status
        status
        url
        link
        audit {
          created_at
          created_by
          updated_at
          updated_by
        }
        item {
          name
        }
        place {
          name
          city
        }
        note {
          type
          date
          value
        }
        approval_status
      }
    }
  }
`;

const usersQuery = gql`
  query searchUsers($input: SearchInput) {
    search_users(input: $input) {
      user_listing {
        user_id
        display_name
        first_name
        last_name
        full_name
        email
      }
    }
  }
`;

const listSize = 10;

const ItemPhotoApprovals = props => {
  const routeState = qs.parse(props.location.search);
  const { status, placeName, itemName, reviewOn, page } = routeState;

  const placeNameFilter = placeName || '';
  const itemNameFilter = itemName || '';
  const statusFilter = status || 'SUBMITTED';
  const reviewOnFilter = reviewOn || null;
  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const [sort, setSort] = useState('CREATED_DESC');
  const [itemNameSort, setItemNameSort] = useState('AES');
  const [citySort, setCitySort] = useState('AES');
  const [uploadedAtSort, setUploadedAtSort] = useState('AES');
  const [uploaderSort, setUploaderSort] = useState('AES');
  const [statusSort, setStatusSort] = useState('AES');

  const [pageCount, setPageCount] = useState(0);
  const [totalElements, setTotalElements] = useState();

  const input = { sort, from: currentPage * listSize, size: listSize };
  const image_review_filter = {};
  Object.assign(
    image_review_filter,
    itemNameFilter && { item_name: itemNameFilter },
    placeNameFilter && { place_name: placeNameFilter },
    { approval_status: statusFilter, object_type: 'ITEM' },

    reviewOnFilter && {
      date_range: {
        start_date: moment(reviewOnFilter).format('YYYY-MM-DD'),
        end_date: moment(reviewOnFilter)
          .add(1, 'day')
          .format('YYYY-MM-DD'),
      },
    },
  );

  Object.assign(
    input,

    {
      filter: {
        image_review_filter,
      },
    },
  );

  return (
    <Layout>
      <Header />
      <Box>
        <Search
          status={statusFilter}
          reviewOn={reviewOnFilter}
          placeName={placeNameFilter}
          itemName={itemNameFilter}
          routeState={routeState}
        />
        <br />
        {totalElements > 0 && (
          <Pagination
            pageFrom={currentPage * listSize}
            pageCount={pageCount}
            listSize={listSize}
            totalElements={totalElements}
            currentPage={currentPage}
            handlePageClick={value =>
              props.history.push(
                `/item-photo-approvals${qs.stringify(
                  {
                    ...routeState,
                    page: value.selected + 1,
                  },
                  true,
                )}`,
              )
            }
          />
        )}

        <Table>
          <thead>
            <tr>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setItemNameSort(itemNameSort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          itemNameSort === 'AES'
                            ? 'ITEM_NAME_DESC'
                            : 'ITEM_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          itemNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>
                    Item Name
                  </span>
                </div>
              </th>

              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setItemNameSort(itemNameSort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          itemNameSort === 'AES'
                            ? 'PLACE_NAME_DESC'
                            : 'PLACE_NAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          itemNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>
                    Place Name
                  </span>
                </div>
              </th>

              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setCitySort(citySort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          citySort === 'AES'
                            ? 'PLACE_CITY_DESC'
                            : 'PLACE_CITY_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          citySort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up '
                        }
                      />
                    </a>{' '}
                    City / Suburb
                  </span>
                </div>
              </th>

              <th>
                <div>
                  <span>
                    {/* <a
                      onClick={() => {
                        setUploaderSort(uploaderSort === 'AES' ? 'DES' : 'AES');
                      }}
                    >
                      <i
                        className={
                          uploaderSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '} */}
                    Uploaded By
                  </span>
                </div>
              </th>

              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setUploadedAtSort(
                          uploadedAtSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          uploadedAtSort === 'AES'
                            ? 'CREATED_DESC'
                            : 'CREATED_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          uploadedAtSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Uploaded At
                  </span>
                </div>
              </th>

              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setStatusSort(statusSort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          statusSort === 'AES' ? 'STATUS_DESC' : 'STATUS_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          statusSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Status
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <Query
            client={client.clientPrivate}
            query={imageReviewsQuery}
            variables={{ input }}
            fetchPolicy="network-only"
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return 'error';
              }

              const { search_image_review } = data;
              if (isNull(search_image_review)) {
                return 'no data found';
              }
              if (search_image_review.length === 0) {
                return 'no data found';
              }

              return (
                <React.Fragment>
                  <View
                    search_image_review={search_image_review}
                    setPageCount={setPageCount}
                    setTotalElements={setTotalElements}
                  />
                </React.Fragment>
              );
            }}
          </Query>
        </Table>
      </Box>
    </Layout>
  );
};

export default ItemPhotoApprovals;

const View = ({ search_image_review, setPageCount, setTotalElements }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setPageCount(search_image_review.total_pages);
    setTotalElements(search_image_review.total_size);
    if (search_image_review.image_review_listing) {
      const userFilter = search_image_review.image_review_listing.map(
        item => item.audit.updated_by,
      );
      client.clientPrivate
        .query({
          query: usersQuery,
          variables: {
            input: { filter: { user_filter: { user_id: uniq(userFilter) } } },
          },
        })
        .then(({ data: { search_users } }) => {
          if (search_users) {
            setUsers(search_users.user_listing);
          }
        });
    }
  }, [search_image_review.total_pages]);

  const imageReviews = search_image_review.image_review_listing;

  return (
    <tbody>
      {imageReviews.map(review => (
        <ListItem review={review} users={users} />
      ))}
    </tbody>
  );
};
